import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import ProfileStore from "../../stores/ProfileStore";
import PrivateTopBarView from "../views/PrivateTopBarView";
import LoadingStates from "../../constants/states/LoadingStates";


class PrivateTopBarContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "profileStoreState": ProfileStore.getState()
        };
    }

    componentDidMount() {
        this.profileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_STORE_UPDATED, this.handleStoreUpdate);
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.profileStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "profileStoreState": ProfileStore.getState()
        });
    };

    render() {
        return (
            <PrivateTopBarView
                dropDownText={
                    this.state.profileStoreState.loadingState === LoadingStates.FINISHED_LOADING ?
                        this.state.profileStoreState.displayName : "Menu"
                }
            />
        );
    }

}

export default PrivateTopBarContainer;